var insta_fun = {
  instagramFeed : function() {
    var access_token, getImages, items_to_load;
    access_token = $('.instagram-widget').data('instagramAccessToken') || "";

    if (access_token.length < 1 || $('.instagram-widget').length < 1) {
      return false;
    }
    items_to_load = 7;
    $('.instagram-widget .items').addClass('wide');
    getImages = function() {
      return $.ajax({
        dataType: "jsonp",
        url: 'https://api.instagram.com/v1/users/self/media/recent/?access_token=' + access_token + '&count=' + items_to_load,
        success: function(response) {
          var data, i, img_src, j, ref, results;
          if (response.meta.code === 200) {
            data = response.data;
            results = [];
            var is_mobile = false;
            if( window.innerWidth < 768 ) {
              is_mobile = true;
            }
            for (i = j = 0, ref = items_to_load - 2; 0 <= ref ? j <= ref : j >= ref; i = 0 <= ref ? ++j : --j) {
              if (data[i]) {
                if(is_mobile) {
                	img_src = data[i].images.thumbnail.url;
                } else {
                	img_src = data[i].images.low_resolution.url;
                }
                img_src = img_src.replace("http:", "https:");
                results.push($('.instagram-widget .items').append('<a class="item anchor_instaimage" href="javascript:void(0)"><img src="' + img_src + '"/></a>'));
              } else {
                results.push(void 0);
              }
            }
            return results;
          } else {
            return $('.instagram-widget .items').append('<p class="error">' + response.meta.error_message + '</p><p class="colored-links">Check the <strong>Homepage - social feeds</strong> section in your <a target="_blank" href="/admin/themes">theme settings</a>.</p>');
          }
        },
        error: function(jqXHR, textStatus) {
          console.log("textStatus", textStatus);
        }
      });
    };
    return getImages();
  }
}

$(document).ready(function() {
  insta_fun.instagramFeed();
});